(function() {
  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
  var RECOMMENDATION_SELECTOR = '[data-section-type="product-recommendations"], .shopify-section--product-recommendations';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function isMobile() {
    return window.innerWidth <= 999;
  }

  function setStyle(node, name, value) {
    if (node) {
      node.style.setProperty(name, value, 'important');
    }
  }

  function clearStyles(node, names) {
    if (node) {
      names.forEach(function(name) {
        node.style.removeProperty(name);
      });
    }
  }

  function clearStylesFromNodes(nodes, names) {
    toArray(nodes).forEach(function(node) {
      clearStyles(node, names);
    });
  }

  function cssEscape(value) {
    return window.CSS && typeof window.CSS.escape === 'function'
      ? window.CSS.escape(String(value || ''))
      : String(value || '').replace(/["\\]/g, '\\$&');
  }

  function showNode(node) {
    if (!node) {
      return;
    }

    node.hidden = false;
    node.removeAttribute('aria-hidden');
    setStyle(node, 'display', 'block');
    setStyle(node, 'visibility', 'visible');
    setStyle(node, 'opacity', '1');
    setStyle(node, 'height', 'auto');
    setStyle(node, 'min-height', '0');
    setStyle(node, 'max-height', 'none');
    setStyle(node, 'overflow', 'visible');
  }

  function normalizeRecommendations(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cardWidth = isMobile() ? Math.min(170, Math.round(window.innerWidth * 0.53)) : 240;

    toArray(scope.querySelectorAll(RECOMMENDATION_SELECTOR)).forEach(function(section) {
      var rail = section.querySelector('.product-list--scrollable, .product-list');
      var viewport = rail && rail.querySelector(':scope > .flickity-viewport');
      var slider = viewport && viewport.querySelector('.flickity-slider');
      var items = slider ? toArray(slider.querySelectorAll('.product-item')) : toArray(rail && rail.querySelectorAll('.product-item'));

      if (rail && slider && items.length) {
        items.forEach(function(item) {
          rail.appendChild(item);
        });
      }

      items = rail ? toArray(rail.children).filter(function(child) {
        return child.classList && child.classList.contains('product-item');
      }) : items;

      if (!rail || !items.length) {
        return;
      }

      section.setAttribute('data-tuokus-recommendations-ready', 'true');
      rail.setAttribute('data-tuokus-recommendation-rail', 'true');

      showNode(section);
      showNode(section.parentElement && section.parentElement.classList && section.parentElement.classList.contains('shopify-section') ? section.parentElement : null);
      showNode(section.querySelector('.section__content'));
      showNode(section.querySelector('.product-recommendations'));

      if (viewport) {
        viewport.hidden = true;
        viewport.setAttribute('aria-hidden', 'true');
        setStyle(viewport, 'display', 'none');
        setStyle(viewport, 'height', '0');
        setStyle(viewport, 'min-height', '0');
        setStyle(viewport, 'max-height', '0');
        setStyle(viewport, 'overflow', 'hidden');
      }

      setStyle(rail, 'display', 'flex');
      setStyle(rail, 'flex-wrap', 'nowrap');
      setStyle(rail, 'align-items', 'stretch');
      setStyle(rail, 'gap', isMobile() ? '12px' : '14px');
      setStyle(rail, 'overflow-x', 'auto');
      setStyle(rail, 'overflow-y', 'hidden');
      setStyle(rail, 'height', 'auto');
      setStyle(rail, 'min-height', '0');
      setStyle(rail, 'max-height', 'none');
      setStyle(rail, 'padding-bottom', '8px');
      setStyle(rail, 'scroll-snap-type', 'none');
      setStyle(rail, '-webkit-overflow-scrolling', 'touch');
      setStyle(rail, 'touch-action', 'pan-x pan-y pinch-zoom');

      items.forEach(function(item) {
        setStyle(item, 'position', 'static');
        setStyle(item, 'left', 'auto');
        setStyle(item, 'transform', 'none');
        setStyle(item, 'display', 'block');
        setStyle(item, 'visibility', 'visible');
        setStyle(item, 'opacity', '1');
        setStyle(item, 'width', cardWidth + 'px');
        setStyle(item, 'min-width', cardWidth + 'px');
        setStyle(item, 'max-width', cardWidth + 'px');
        setStyle(item, 'flex', '0 0 ' + cardWidth + 'px');
      });
    });
  }

  function resetDesktopMedia(root) {
    var scope = root && root.querySelectorAll ? root : document;

    toArray(scope.querySelectorAll(PRODUCT_SECTION_SELECTOR)).forEach(function(section) {
      var gallery = section.querySelector('.product-gallery');
      var viewport = gallery && gallery.querySelector('.product-gallery__carousel > .flickity-viewport');
      var wrappers = gallery ? toArray(gallery.querySelectorAll('.product-gallery__carousel-wrapper, .product-gallery__carousel, .product-gallery__carousel-item, .product-gallery__carousel-item .aspect-ratio, .product-gallery__size-limiter, .flickity-slider')) : [];
      var thumbWrapper = gallery && gallery.querySelector(':scope > .scroller, .product-gallery__thumbnail-list-wrapper');
      var thumbInner = thumbWrapper && thumbWrapper.querySelector('.scroller__inner');
      var thumbList = gallery && gallery.querySelector('.product-gallery__thumbnail-list');
      var carousel = gallery && gallery.querySelector('.product-gallery__carousel');
      var carouselWrapper = gallery && gallery.querySelector('.product-gallery__carousel-wrapper');
      var carouselItems = gallery ? toArray(gallery.querySelectorAll('.product-gallery__carousel-item')) : [];
      var aspectRatios = gallery ? toArray(gallery.querySelectorAll('.product-gallery__carousel-item .aspect-ratio, .product-gallery__size-limiter')) : [];
      var galleryImages = gallery ? toArray(gallery.querySelectorAll('.product-gallery__carousel-item img')) : [];
      var slider = gallery && gallery.querySelector('.flickity-slider');
      var stageSize = 0;

      clearStyles(gallery, ['display', 'min-height', 'height', 'max-height', 'margin-left', 'margin-right', 'width', 'min-width', 'max-width']);
      [viewport].concat(wrappers).forEach(function(node) {
        clearStyles(node, ['aspect-ratio', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height', 'background']);
      });
      clearStyles(carouselWrapper, ['display', 'padding', 'margin-left', 'margin-right']);
      clearStyles(carousel, ['display', 'padding', 'margin-left', 'margin-right']);
      clearStyles(viewport, ['left', 'padding', 'box-sizing']);
      clearStyles(slider, ['position', 'left', 'transform']);
      clearStylesFromNodes(carouselItems, ['display', 'visibility', 'opacity', 'align-items', 'justify-content', 'left', 'transform', 'padding', 'box-sizing', 'background', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height']);
      clearStylesFromNodes(aspectRatios, ['display', 'align-items', 'justify-content', 'padding-bottom', 'overflow', 'box-sizing', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height']);
      clearStylesFromNodes(galleryImages, ['position', 'object-position', 'margin', 'display', 'padding', 'box-sizing', 'width', 'height', 'min-height', 'max-width', 'max-height', 'object-fit', 'background']);
      [thumbWrapper, thumbInner, thumbList].forEach(function(node) {
        clearStyles(node, ['position', 'left', 'right', 'transform', 'margin-left', 'margin-right']);
      });
      clearStyles(thumbWrapper, ['display', 'box-sizing', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height', 'margin', 'overflow-x', 'overflow-y', '-webkit-overflow-scrolling', 'touch-action', 'padding', 'scroll-snap-type', 'scroll-behavior']);
      clearStyles(thumbInner, ['display', 'box-sizing', 'width', 'min-width', 'max-width', 'height', 'overflow']);
      clearStyles(thumbList, ['display', 'position', 'width', 'min-width', 'max-width', 'height', 'max-height', 'flex-direction', 'flex-wrap', 'align-items', 'justify-content', 'gap', 'margin', 'padding', 'overflow']);

      stageSize = carousel ? Math.round(carousel.getBoundingClientRect().width) : 0;
      if (stageSize > 0) {
        [carouselWrapper, carousel, viewport].forEach(function(node) {
          setStyle(node, 'aspect-ratio', '1 / 1');
          setStyle(node, 'height', stageSize + 'px');
          setStyle(node, 'min-height', stageSize + 'px');
          setStyle(node, 'max-height', stageSize + 'px');
          setStyle(node, 'background', '#f8f3eb');
        });
        carouselItems.forEach(function(item) {
          setStyle(item, 'width', '100%');
          setStyle(item, 'min-width', '100%');
          setStyle(item, 'max-width', '100%');
          setStyle(item, 'height', stageSize + 'px');
        });
        aspectRatios.forEach(function(node) {
          setStyle(node, 'width', '100%');
          setStyle(node, 'height', stageSize + 'px');
          setStyle(node, 'min-height', stageSize + 'px');
          setStyle(node, 'max-height', stageSize + 'px');
          setStyle(node, 'padding-bottom', '0');
        });
        toArray(gallery.querySelectorAll('.product-gallery__carousel-item img')).forEach(function(image) {
          setStyle(image, 'width', '100%');
          setStyle(image, 'height', stageSize + 'px');
          setStyle(image, 'min-height', stageSize + 'px');
          setStyle(image, 'max-height', stageSize + 'px');
          setStyle(image, 'object-fit', 'contain');
          setStyle(image, 'background', '#f8f3eb');
        });
        setStyle(thumbWrapper, 'height', stageSize + 'px');
        setStyle(thumbWrapper, 'max-height', stageSize + 'px');
        setStyle(thumbWrapper, 'overflow-y', 'auto');
        setStyle(thumbWrapper, 'overflow-x', 'hidden');
      }

      if (window.Flickity && carousel) {
        try {
          var flkty = window.Flickity.data(carousel);
          if (flkty) {
            if (typeof flkty.reloadCells === 'function') {
              flkty.reloadCells();
            }
            flkty.resize();
          }
        } catch (error) {
        }
      }
    });
  }

  function normalizeMobileMedia(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (!isMobile()) {
      resetDesktopMedia(scope);
      return;
    }

    toArray(scope.querySelectorAll(PRODUCT_SECTION_SELECTOR)).forEach(function(section) {
      var gallery = section.querySelector('.product-gallery');
      var viewport = gallery && gallery.querySelector('.product-gallery__carousel > .flickity-viewport');
      var wrappers = gallery ? toArray(gallery.querySelectorAll('.product-gallery__carousel-wrapper, .product-gallery__carousel, .product-gallery__carousel-item, .product-gallery__carousel-item .aspect-ratio')) : [];
      var thumbWrapper = gallery && gallery.querySelector(':scope > .scroller, .product-gallery__thumbnail-list-wrapper');
      var thumbInner = thumbWrapper && thumbWrapper.querySelector('.scroller__inner');
      var thumbList = gallery && gallery.querySelector('.product-gallery__thumbnail-list');
      var swatchRail = section.querySelector('.product-form__option--visual .variant-swatch-list, .variant-swatch-list');

      if (gallery) {
        setStyle(gallery, 'margin-left', 'auto');
        setStyle(gallery, 'margin-right', 'auto');
      }

      [viewport].concat(wrappers).forEach(function(node) {
        setStyle(node, 'aspect-ratio', '1 / 1');
        setStyle(node, 'height', 'auto');
        setStyle(node, 'min-height', '0');
        setStyle(node, 'background', '#f8f3eb');
      });

      toArray(gallery && gallery.querySelectorAll('.product-gallery__carousel-item img')).forEach(function(image) {
        setStyle(image, 'width', '100%');
        setStyle(image, 'height', '100%');
        setStyle(image, 'min-height', '0');
        setStyle(image, 'max-height', '100%');
        setStyle(image, 'object-fit', 'contain');
        setStyle(image, 'background', '#f8f3eb');
      });

      [thumbWrapper, thumbInner, thumbList].forEach(function(node) {
        if (!node) {
          return;
        }
        setStyle(node, 'position', 'static');
        setStyle(node, 'left', '0');
        setStyle(node, 'right', 'auto');
        setStyle(node, 'transform', 'none');
        setStyle(node, 'margin-left', '0');
        setStyle(node, 'margin-right', '0');
      });

      if (thumbWrapper) {
        setStyle(thumbWrapper, 'display', 'block');
        setStyle(thumbWrapper, 'width', '100%');
        setStyle(thumbWrapper, 'max-width', '100%');
        setStyle(thumbWrapper, 'overflow-x', 'auto');
        setStyle(thumbWrapper, 'overflow-y', 'hidden');
        setStyle(thumbWrapper, '-webkit-overflow-scrolling', 'touch');
        setStyle(thumbWrapper, 'touch-action', 'pan-x pan-y pinch-zoom');
      }

      if (thumbList) {
        setStyle(thumbList, 'display', 'flex');
        setStyle(thumbList, 'flex-wrap', 'nowrap');
        setStyle(thumbList, 'justify-content', 'flex-start');
        setStyle(thumbList, 'gap', '7px');
      }

      if (swatchRail && !section.classList.contains('tuokus-product-layout')) {
        setStyle(swatchRail, 'display', 'flex');
        setStyle(swatchRail, 'flex-wrap', 'nowrap');
        setStyle(swatchRail, 'gap', '4px');
        setStyle(swatchRail, 'column-gap', '4px');
        setStyle(swatchRail, 'overflow-x', 'auto');
        setStyle(swatchRail, 'overflow-y', 'hidden');
        setStyle(swatchRail, 'padding', '0 0 2px');
        setStyle(swatchRail, 'margin', '0');
        setStyle(swatchRail, 'scroll-snap-type', 'none');
        setStyle(swatchRail, '-webkit-overflow-scrolling', 'touch');
        setStyle(swatchRail, 'touch-action', 'pan-x pan-y pinch-zoom');

        toArray(swatchRail.children).forEach(function(item) {
          setStyle(item, 'box-sizing', 'border-box');
          setStyle(item, 'flex', '0 0 76px');
          setStyle(item, 'width', '76px');
          setStyle(item, 'min-width', '76px');
          setStyle(item, 'max-width', '76px');
          setStyle(item, 'height', '76px');
          setStyle(item, 'min-height', '76px');
          setStyle(item, 'max-height', '76px');
          setStyle(item, 'margin', '0');
          setStyle(item, 'padding', '0');
        });

        toArray(swatchRail.querySelectorAll('.variant-swatch__item')).forEach(function(item) {
          setStyle(item, 'width', '76px');
          setStyle(item, 'height', '76px');
          setStyle(item, 'padding', '4px');
        });

        toArray(swatchRail.querySelectorAll('.variant-swatch__media, .variant-swatch__image')).forEach(function(media) {
          setStyle(media, 'width', '68px');
          setStyle(media, 'height', '68px');
        });

        toArray(swatchRail.querySelectorAll('.variant-swatch__label')).forEach(function(label) {
          setStyle(label, 'display', 'none');
          setStyle(label, 'height', '0');
          setStyle(label, 'margin', '0');
          setStyle(label, 'padding', '0');
          setStyle(label, 'overflow', 'hidden');
        });
      }
    });
  }

  function getRailSelectedItem(rail) {
    var checked = rail ? rail.querySelector('input:checked') : null;
    var label = null;

    if (checked) {
      label = checked.closest('.variant-swatch, .block-swatch, .color-swatch');
      if (!label && checked.id) {
        label = rail.querySelector('label[for="' + cssEscape(checked.id) + '"]');
      }
    }

    return label || (rail ? rail.querySelector('.is-selected, [aria-checked="true"]') : null);
  }

  function keepRailItemVisible(rail, item) {
    var railRect = null;
    var itemRect = null;
    var itemLeft = 0;
    var itemRight = 0;
    var targetScrollLeft = 0;
    var maxScrollLeft = 0;
    var padding = 8;

    if (!rail || !item || rail.scrollWidth <= rail.clientWidth + 4) {
      return;
    }

    railRect = rail.getBoundingClientRect();
    itemRect = item.getBoundingClientRect();

    if (itemRect.left >= railRect.left + 4 && itemRect.right <= railRect.right - 4) {
      return;
    }

    itemLeft = itemRect.left - railRect.left + rail.scrollLeft;
    itemRight = itemRect.right - railRect.left + rail.scrollLeft;
    targetScrollLeft = rail.scrollLeft;

    if (itemLeft - padding < rail.scrollLeft) {
      targetScrollLeft = itemLeft - padding;
    } else if (itemRight + padding > rail.scrollLeft + rail.clientWidth) {
      targetScrollLeft = itemRight + padding - rail.clientWidth;
    }

    maxScrollLeft = Math.max(rail.scrollWidth - rail.clientWidth, 0);
    rail.scrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
  }

  function normalizeVariantRails(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var mobile = isMobile();
    var productRefresh = !!document.querySelector('link[href*="tuokus-product-refresh.css"]');

    toArray(scope.querySelectorAll(PRODUCT_SECTION_SELECTOR)).forEach(function(section) {
      toArray(section.querySelectorAll('.variant-swatch-list, .block-swatch-list, .color-swatch-list--large')).forEach(function(rail) {
        var isVisualRail = rail.classList.contains('variant-swatch-list') || rail.classList.contains('color-swatch-list--large');

        setStyle(rail, 'display', 'flex');
        setStyle(rail, 'align-items', 'center');
        setStyle(rail, 'scroll-behavior', 'auto');
        setStyle(rail, 'scroll-snap-type', 'none');
        setStyle(rail, 'overscroll-behavior-x', 'contain');
        setStyle(rail, '-webkit-overflow-scrolling', 'touch');
        setStyle(rail, 'touch-action', 'pan-x pan-y pinch-zoom');

        if (mobile) {
          setStyle(rail, 'flex-wrap', section.classList.contains('tuokus-product-layout') && !isVisualRail ? 'wrap' : 'nowrap');
          setStyle(rail, 'justify-content', 'flex-start');
          setStyle(rail, 'overflow-x', section.classList.contains('tuokus-product-layout') && !isVisualRail ? 'visible' : 'auto');
          setStyle(rail, 'overflow-y', section.classList.contains('tuokus-product-layout') && !isVisualRail ? 'visible' : 'hidden');
          setStyle(rail, 'gap', isVisualRail ? '4px' : '8px');
          setStyle(rail, 'column-gap', isVisualRail ? '4px' : '8px');
          setStyle(rail, 'padding', '0 0 2px');
          setStyle(rail, 'margin-top', '0');
        } else {
          setStyle(rail, 'flex-wrap', isVisualRail && productRefresh && !section.classList.contains('tuokus-product-layout') ? 'nowrap' : 'wrap');
          setStyle(rail, 'justify-content', 'flex-start');
          setStyle(rail, 'overflow-x', isVisualRail && productRefresh && !section.classList.contains('tuokus-product-layout') ? 'auto' : 'visible');
          setStyle(rail, 'overflow-y', isVisualRail && productRefresh && !section.classList.contains('tuokus-product-layout') ? 'hidden' : 'visible');
          setStyle(rail, 'gap', isVisualRail ? '8px' : '10px');
          setStyle(rail, 'column-gap', isVisualRail ? '8px' : '10px');
          setStyle(rail, 'padding', '0');
          setStyle(rail, 'touch-action', 'auto');
        }

        if (mobile && isVisualRail && !section.classList.contains('tuokus-product-layout')) {
          toArray(rail.children).forEach(function(item) {
            setStyle(item, 'box-sizing', 'border-box');
            setStyle(item, 'flex', '0 0 76px');
            setStyle(item, 'width', '76px');
            setStyle(item, 'min-width', '76px');
            setStyle(item, 'max-width', '76px');
            setStyle(item, 'height', '76px');
            setStyle(item, 'min-height', '76px');
            setStyle(item, 'max-height', '76px');
            setStyle(item, 'margin', '0');
            setStyle(item, 'padding', '0');
          });

          toArray(rail.querySelectorAll('.variant-swatch__item')).forEach(function(item) {
            setStyle(item, 'width', '76px');
            setStyle(item, 'height', '76px');
            setStyle(item, 'padding', '4px');
          });

          toArray(rail.querySelectorAll('.variant-swatch__media, .variant-swatch__image')).forEach(function(media) {
            setStyle(media, 'width', '68px');
            setStyle(media, 'height', '68px');
          });

          toArray(rail.querySelectorAll('.variant-swatch__label')).forEach(function(label) {
            setStyle(label, 'display', 'none');
            setStyle(label, 'height', '0');
            setStyle(label, 'margin', '0');
            setStyle(label, 'padding', '0');
            setStyle(label, 'overflow', 'hidden');
          });
        }

        if (mobile && rail.classList.contains('block-swatch-list')) {
          toArray(rail.querySelectorAll('.block-swatch__item')).forEach(function(item) {
            setStyle(item, 'display', 'inline-flex');
            setStyle(item, 'align-items', 'center');
            setStyle(item, 'justify-content', 'center');
            setStyle(item, 'white-space', 'nowrap');
          });
        }

        if (!mobile && isVisualRail) {
          toArray(rail.children).forEach(function(item) {
            clearStyles(item, ['box-sizing', 'flex', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height', 'margin', 'padding']);
          });
          toArray(rail.querySelectorAll('.variant-swatch__item, .variant-swatch__media, .variant-swatch__image, .variant-swatch__label')).forEach(function(item) {
            clearStyles(item, ['display', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height', 'padding', 'margin', 'overflow']);
          });
        }

        if (!mobile && rail.classList.contains('block-swatch-list')) {
          toArray(rail.querySelectorAll('.block-swatch__item')).forEach(function(item) {
            clearStyles(item, ['display', 'align-items', 'justify-content', 'white-space']);
          });
        }
      });
    });
  }

  function keepSelectedVariantVisible(root) {
    var scope = root && root.querySelectorAll ? root : document;

    toArray(scope.querySelectorAll('.variant-swatch-list, .block-swatch-list, .color-swatch-list--large')).forEach(function(rail) {
      keepRailItemVisible(rail, getRailSelectedItem(rail));
    });
  }

  function restoreDocumentScroll(position) {
    if (position && (window.scrollX !== position.x || window.scrollY !== position.y)) {
      window.scrollTo(position.x, position.y);
    }
  }

  var variantVisibilityFrame = null;

  function scheduleSelectedVariantVisibility(root, documentScroll) {
    if (variantVisibilityFrame !== null) {
      window.cancelAnimationFrame(variantVisibilityFrame);
    }
    variantVisibilityFrame = window.requestAnimationFrame(function() {
      variantVisibilityFrame = null;
      normalizeVariantRails(root || document);
      keepSelectedVariantVisible(root || document);
      if (documentScroll) {
        restoreDocumentScroll(documentScroll);
      }
    });
  }

  function run(root) {
    normalizeRecommendations(root || document);
    normalizeMobileMedia(root || document);
    normalizeVariantRails(root || document);
  }

  function schedule() {
    run(document);
    [400, 900, 1800, 3600, 6500].forEach(function(delay) {
      window.setTimeout(function() {
        run(document);
      }, delay);
    });
  }

  var viewportFrame = null;

  function scheduleViewportRefresh() {
    if (viewportFrame !== null) {
      window.cancelAnimationFrame(viewportFrame);
    }

    viewportFrame = window.requestAnimationFrame(function() {
      viewportFrame = null;
      schedule();
    });
  }

  window.__TUOKUS_RAIL_MEMORY_DISABLED = true;

  document.addEventListener('click', function(event) {
    var rail = event.target && event.target.closest ? event.target.closest('.variant-swatch-list, .block-swatch-list, .color-swatch-list--large') : null;
    var documentScroll = rail ? { x: window.scrollX, y: window.scrollY } : null;
    if (rail) {
      scheduleSelectedVariantVisibility(rail.closest(PRODUCT_SECTION_SELECTOR) || document, documentScroll);
    }
  }, true);

  ['change', 'variant:change', 'variant:changed', 'product:rerender', 'theme:loading:end'].forEach(function(eventName) {
    document.addEventListener(eventName, function(event) {
      var section = event.target && event.target.closest ? event.target.closest(PRODUCT_SECTION_SELECTOR) : null;
      scheduleSelectedVariantVisibility(section || document);
    }, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', scheduleViewportRefresh);

  if (window.matchMedia) {
    var mobileMediaQuery = window.matchMedia('(max-width: 999px)');
    if (typeof mobileMediaQuery.addEventListener === 'function') {
      mobileMediaQuery.addEventListener('change', scheduleViewportRefresh);
    } else if (typeof mobileMediaQuery.addListener === 'function') {
      mobileMediaQuery.addListener(scheduleViewportRefresh);
    }
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleViewportRefresh);
  }

  if (window.MutationObserver && document.body) {
    var timer = null;
    new MutationObserver(function() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function() {
        run(document);
      }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
